import React from 'react'
import { styled } from 'styled-components'
import patronImage from '../../assets/images/chief_patreon.jpg'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

const LeadershipIntro = () => {

  return (
    <Wrapper>
        <ScrollToTop />
        <Container>
            <div className="message-info">
                <div className="patreon-inform-box">
                    <img src={patronImage} alt="The Chief Patron of AMRS" />
                    <h6>@ Welcome Address from the Chief Patron</h6>
                </div>
                <p> Dear Esteemed Readers,</p>
                <p className='main-message'>
                    <p>
                        "It is with immense pleasure and a sense of profound honor that I extend my warmest greetings
                        to each one of you as the Chief Patron of the African Materials Research Society (AMRS)
                        University of Ghana students’ chapter. I am filled with enthusiasm and optimism for the
                        remarkable journey that lies ahead.
                    </p>
                    <p>
                        AMRS has always been a vibrant hub of intellect, creativity, camaraderie and hardwork. It is a
                        place where like-minded students come together to explore their passions, cultivate new skills,
                        and forge lifelong friendships. Over the years, it has evolved into a community that nurtures not
                        only academic excellence but also personal growth and cultural enrichment.
                        The essence of any successful research society lies in its ability to adapt and thrive amidst
                        changing times. In this age of constant transformation and innovation, we will continue to be at
                        the forefront, offering a platform for our students to explore their interests and contribute to
                        the betterment of society.
                    </p>
                    <p>
                        I want to take this moment to acknowledge the dedication and hard work of the chapter’s
                        executive committee, faculty advisory team, and, most importantly, our passionate members.
                        Your unwavering commitment to excellence has been the driving force behind the chapter’s
                        success.
                        As we look forward, let us remember that our chapter is more than just an organization; it is a
                        family. It is a place where talents are discovered, dreams are realized, and aspirations are given
                        wings to soar. Together, we will create a nurturing environment that fosters innovation,
                        celebrates diversity, and empowers every member to reach their full potential.
                        I encourage each and every one of you to actively participate, share your ideas, and seize the
                        countless opportunities that our university club offers. Embrace this journey with an open heart
                        and an open mind, for it is through your involvement and enthusiasm that we will continue to
                        flourish.
                    </p>
                    <p>
                        In closing, I would like to express my deepest gratitude to all our members, supporters, and
                        partners who have been instrumental in shaping our chapter’s legacy. Together, we will chart
                        new horizons and create a brighter future.
                    </p>
                    <p>
                        Thank you for being part of our incredible community, and I look forward to witnessing the
                        remarkable achievements and memories we will create together in the days to come."
                    </p>
                </p>
                <br />
                <p>
                    Warm regards,<br />
                    Professor Benjamin Agyei-Tuffour <br />
                    Chief Patron, African Materials Research Society (AMRS) GHANA
                </p>
            </div>       
        </Container>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const Container = styled.div`
    text-align: center;
    background-color: whitesmoke;
    padding: 3em 1em;
    .patreon-inform-box{
        img{
        object-fit: cover;
        width: 6em;
        height: 6em;
        border-radius: 50%;
        }
        h6{
        font-size: 1.5rem;
        font-weight: bolder;
        margin: 1em auto;
    }
    }
    p{
        font-size: 1.3rem;
        color: var(--color-black);
        font-weight: lighter;
        margin: 1em 0;
        text-align: justify;
    }

    /* Media Queries */
    @media only screen and (min-width: 800px){
        text-align: unset;
        padding: 3em 5em;
        .patreon-inform-box{
            display: flex;
            align-items: center;
            margin: 2em auto;
            img{
            width: 5em;
            height: 5em; 
            }
            h6{
            font-size: 2rem;
            margin: unset;
            margin-left: 1em;
        }
        }
        p{
            font-size: 1.3rem;
        }
    }

    @media only screen and (min-width: 1200px){
      
    }

`;

export default LeadershipIntro